import React from 'react'
import { useHistory } from 'react-router-dom'
import { TickOutlineIcon } from '@mote/assets/icons'
import { OnboardingLayout } from '../../layouts'
import { MessageCard } from '../Onboarding/components'

export const CheckoutSchoolsThanksScreen = () => {
  const history = useHistory()
  return (
    <OnboardingLayout skipGreeting>
      <MessageCard
        title='Thanks!'
        message='We will review your request and send you a quote or request for more
            information within the next 2 working days.'
        icon={
          <TickOutlineIcon width={60} height={60} style={{ margin: '-12px' }} />
        }
        ctaProps={{
          text: 'Return home',
          onClick: () => {
            history.push('/')
          }
        }}
      />
    </OnboardingLayout>
  )
}
